import Axios from 'axios';
const baseURL = "https://api.mailgun.net/v3/sandbox87ee5ceacb124b62bf0500c6a4480129.mailgun.org/messages";
const config = {
    headers: { Authorization: "api:9fbdc2fc9d52f56e0ada4ff114068ccc-bbbc8336-bd73c3b1" }
}

export default {
    send(d) {
        // var data = JSON.stringify({
        //     "to": "abdullah@venturexlabs.pk",
        //     "from": "ceo@venturexlabs.pk",
        //     "subject": "'Design Your Model S | Tesla'",
        //     "html": "<h1>Have the most fun you can in a car!</h1><p>Get your <b>Tesla</b> today!</p>",
        //     "attachments": [
        //       {
        //         "filename": "your-testla.png",
        //         "path": "https://media.gettyimages.com/photos/view-of-tesla-model-s-in-barcelona-spain-on-september-10-2018-picture-id1032050330?s=2048x2048"
        //       }
        //     ]
        //   });

        // return new Promise((resolve, reject) => {
        //     var xhr = new XMLHttpRequest();
        //     xhr.withCredentials = true;

        //     xhr.addEventListener("readystatechange", function () {
        //         if (this.readyState === 4 && xhr.status === 200) {
        //             try {
        //                 let res = JSON.parse(this.responseText);
        //                 resolve(res);
        //             } catch (error) {
        //                 reject(error);
        //             }

        //         }

        //     });

        //     // xhr.open("POST", "https://email-server-fse.herokuapp.com/send");
        //     xhr.open("POST", "http://localhost:5000/temp");
        //     xhr.setRequestHeader("content-type", "application/json");
        //     xhr.setRequestHeader("authorization", "Basic YWJkdWxsYWg6MTIzNDU=");    
        //     xhr.send(data);
        // });

        return Axios.post("https://email-server-fse.herokuapp.com/send",d,{headers:{"Authorization": "Basic YWJkdWxsYWg6MTIzNDU="}});
    }
};
